import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { LOGO_WHITE, CONTACT, INSTAGRAM } from "../data/content";

const SOCIAL_ICONS = { Instagram, Facebook };

export const Footer = () => (
  <footer data-testid="footer" className="wood-band text-white pt-20 pb-10">
    <div className="container-blum">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-4">
          <img src={LOGO_WHITE} alt="Fussboden Blum" className="h-16 w-auto mb-6" />
          <p className="text-white/70 leading-relaxed max-w-sm">
            Seit über 55 Jahren Ihr Meisterbetrieb für Parkett und Fußbodentechnik in Kalbach.
            Qualität, die man sieht – Kompetenz, die man spürt.
          </p>
          <p className="font-script text-2xl text-[#D7C4B1] mt-6">sicher · boden · ständig</p>

          <div data-testid="footer-social" className="mt-8">
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.18em] text-white/50 mb-4">
              Fussboden Blum auf Social Media
            </h4>
            <div className="flex flex-col sm:flex-row gap-3">
              {CONTACT.social.map((s) => {
                const Icon = SOCIAL_ICONS[s.icon];
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`social-${s.name.toLowerCase()}`}
                    className="group flex items-center gap-3 bg-white/5 border border-white/10 hover:border-[#D32F2F] hover:bg-white/10 px-4 py-3 transition-colors"
                  >
                    <span className="w-9 h-9 flex items-center justify-center bg-[#D32F2F] shrink-0 transition-transform group-hover:scale-105">
                      <Icon className="w-5 h-5 text-white" />
                    </span>
                    <span className="leading-tight">
                      <span className="block font-display font-semibold text-white text-sm">{s.name}</span>
                      <span className="block text-white/55 text-xs">{s.handle}</span>
                    </span>
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-display font-semibold text-sm uppercase tracking-[0.18em] text-white/50 mb-5">Navigation</h4>
          <ul className="space-y-3 text-white/80">
            <li><Link to="/" className="hover:text-[#D32F2F] transition-colors">Startseite</Link></li>
            <li><Link to="/unternehmen" className="hover:text-[#D32F2F] transition-colors">Unternehmen</Link></li>
            <li><Link to="/produkte" className="hover:text-[#D32F2F] transition-colors">Produkte</Link></li>
            <li><Link to="/leistungen" className="hover:text-[#D32F2F] transition-colors">Leistungen</Link></li>
            <li><a href={INSTAGRAM.url} target="_blank" rel="noopener noreferrer" data-testid="footer-referenzen-instagram" className="hover:text-[#D32F2F] transition-colors">Referenzen (Instagram)</a></li>
          </ul>
        </div>

        <div className="lg:col-span-5">
          <h4 className="font-display font-semibold text-sm uppercase tracking-[0.18em] text-white/50 mb-5">Kontakt & Öffnungszeiten</h4>
          <p className="text-white/85 mb-6 -mt-2">Bitte vereinbaren Sie einen persönlichen Beratungstermin mit uns.</p>
          <ul className="space-y-4 text-white/85">
            <li className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[#D32F2F] mt-0.5 shrink-0" />
              <span>{CONTACT.street}, {CONTACT.city}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-[#D32F2F] shrink-0" />
              <a href={CONTACT.phoneHref} className="hover:text-white">{CONTACT.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-[#D32F2F] shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a>
            </li>
            {CONTACT.hours.map((h) => (
              <li key={h.d} className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#D32F2F] mt-0.5 shrink-0" />
                <span>{h.d && <span className="font-medium">{h.d}: </span>}{h.t}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-white/50 text-sm">
        <p>© {new Date().getFullYear()} Fussboden Blum GmbH. Alle Rechte vorbehalten.</p>
        <div className="flex gap-6">
          <Link to="/impressum" data-testid="footer-impressum" className="hover:text-white">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white">Datenschutz</Link>
        </div>
      </div>
    </div>
  </footer>
);
